export default {
  cardholder_name: 'Vollständiger Name',
  cardholder_name_placeholder: 'Name auf der Karte',
  card_number: 'Kartennummer',
  card_number_placeholder: '1234 5678 9012 3456',
  expiry: 'Ablaufdatum',
  expiry_placeholder: 'MM / JJ',
  cvv: 'Sicherheitscode',
  cvv_label: 'Sicherheitscode (CVC)',
  cvv_placeholder: 'CVC',
  loading: 'Sicheres Kartenformular wird geladen…',
  sdk_load_failed:
    'Das sichere Kartenformular konnte nicht geladen werden. Prüfe deine Verbindung und lade die Seite neu.',
  errors: {
    number_blank: 'Gib deine Kartennummer ein.',
    number_invalid: 'Diese Kartennummer ist ungültig. Prüfe die Ziffern und versuche es erneut.',
    number_incomplete: 'Deine Kartennummer ist unvollständig.',
    cvv_blank: 'Gib den Sicherheitscode auf der Rückseite deiner Karte ein.',
    cvv_invalid: 'Dieser Sicherheitscode ist ungültig. Prüfe die 3 oder 4 Ziffern auf deiner Karte.',
    cvv_incomplete: 'Gib alle {{count}} Ziffern deines Sicherheitscodes ein.',
    expiry_invalid: 'Gib ein gültiges Ablaufdatum im Format MM / JJ ein.',
    expired: 'Diese Karte ist abgelaufen. Bitte nutze eine andere Karte.',
    name_blank: 'Gib den Namen genau so ein, wie er auf deiner Karte steht.',
    configuration: 'Kartenzahlungen sind gerade nicht möglich. Bitte wähle eine andere Zahlungsmethode.',
    generic: 'Wir konnten deine Kartendaten nicht prüfen. Bitte versuche es erneut.',
  },
};
